import { Suspense } from "react";
import Board from "./Board/Board";

import ClueboardBase from "./ClueBoardBase/ClueboardBase";

const ClueBoard = () => {
  return (
    <ClueboardBase>
      <Suspense fallback={<div>Loading..</div>}>
        <Board isFlashes={false} />
      </Suspense>
    </ClueboardBase>
  );
};

export default ClueBoard;
